module.exports = __webpack_public_path__ + "src/assets/games/14/36.jpg";